import { SelectedSort } from '@/hooks/useSortableData';
import { ColumnConfig } from './Table';
import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
} from '@mui/icons-material';
import { useMemo } from 'react';

interface SortableRowProps {
  column: ColumnConfig;
  selectedSort?: SelectedSort;
}

export const SortableRow = ({ column, selectedSort }: SortableRowProps) => {
  const isSorted = useMemo(
    () =>
      ['asc', 'desc'].includes(selectedSort?.direction || 'default') &&
      selectedSort?.key === column?.field,
    [selectedSort]
  );

  return (
    <>
      {column?.sortable && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <KeyboardArrowUpIcon
            fontSize='small'
            style={{
              color: 'currentColor',
              opacity: isSorted && selectedSort?.direction === 'asc' ? 1 : 0.35,
            }}
          />
          <KeyboardArrowDownIcon
            fontSize='small'
            style={{
              color: 'currentColor',
              opacity: isSorted && selectedSort?.direction === 'desc' ? 1 : 0.35,
            }}
          />
        </div>
      )}
    </>
  );
};
